import { NextPageWithLayout } from 'next';
import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import Layout from '../components/Layout';
import correctLocalizedRoute from '../lib/correctLocalizedRoute';
import LinkAndAnchor from '../components/LinkAndAnchor';
import messages from '../lib/messages';
import HomeLink from '../components/HomeLink';
import Head from '../components/Head';
import { useSiteContext } from '../components/SiteContext';

const EditorialStatutePage: NextPageWithLayout = () => {
  const intl = useIntl();
  const { locale } = useSiteContext();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route={`editorial-statute.${locale}`}
      passHref
    >
      {intl.formatMessage(messages.editorialStatute)}
    </LinkAndAnchor>,
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages.editorialStatute)}
        description={intl.formatMessage(messages.editorialStatute)}
      />
      <StaticPageComponent
        content={(
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: intl.formatMessage(messages['editorialStatute.content']),
            }}
          />
        )}
        title={intl.formatMessage(messages.editorialStatute)}
        breadcrumbs={breadcrumbs}
      />
    </>
  );
};

EditorialStatutePage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

EditorialStatutePage.getInitialProps = (context) => {
  correctLocalizedRoute(context, 'editorial-statute');
  return {};
};

export default EditorialStatutePage;
